module.exports = __webpack_public_path__ + "static/media/ic_hs_cover_amount.af61181f.svg";